import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _4kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"4k_plus"}/>
}
